import { Dispatch } from "redux";
import siteConfig from "site-config";
import { PRODUCT_MEDIA } from "constants/action-types";
import { IMediaState } from "reducers/product-media-reducers";
import { MEDIA_TYPE_IMAGE, MEDIA_TYPE_360, MEDIA_TYPE_VIDEO, MEDIA_TYPE_THREEDIUM } from "constants/media";
import { IImageAsset, I360Asset, IVideoAsset, I3DAsset } from "constants/assets";
import { IStore } from "reducers";
import { ICoreMediaAssetMap, IUpdateMediaAssetOperation } from "../constants/media-asset";
import _ from "lodash";

export const MUTATE_OPERATION_TYPES = { SET: "set", REMOVE: "remove", CLEAR: "clear" };

export const fetchMediaAssets = (id: string) => ({
    type: PRODUCT_MEDIA.MEDIA_ASSETS.FETCH.START,
    payload: { url: `${siteConfig.goAPI}/v1/coreproduct/${id}/media` },
});

export const uploadImage = (product: string, value: string) => (dispatch: Dispatch<{}>) =>
    dispatch(
        upload(product, {
            kind: MEDIA_TYPE_IMAGE,
            media_resource: { image: { upload_id: value } },
        }),
    );

export const upload360 = (product: string, values: string[]) => (dispatch: Dispatch<{}>) =>
    dispatch(
        upload(product, {
            kind: MEDIA_TYPE_360,
            media_resource: { image_360: { upload_ids: { values } } },
        }),
    );

export const uploadVideo = (product: string, upload_id: string) => (dispatch: Dispatch<{}>) =>
    dispatch(
        upload(product, {
            kind: MEDIA_TYPE_VIDEO,
            media_resource: { video: { upload_id } },
        }),
    );

export const upload3D = (product: string, value: string) => (dispatch: Dispatch<{}>) =>
    dispatch(
        upload(product, {
            kind: MEDIA_TYPE_THREEDIUM,
            media_resource: { threedium: { upload_id: value } },
        }),
    );

export const save = (product: string, asset_ids: string[]) => ({
    type: PRODUCT_MEDIA.MUTATE.START,
    payload: {
        url: `${siteConfig.goAPI}/v1/coreproducts/${product}/media`,
        body: { asset_ids },
    },
});

export const mutateMediaAssets = (
    productId: string,
    revision: string,
    mediaMap: ICoreMediaAssetMap,
    mutateOperations: IUpdateMediaAssetOperation[] = [],
    errors?: Array<any>,
) => {
    const operations = [...mutateOperations, { [MUTATE_OPERATION_TYPES.CLEAR]: {} }];
    _.keys(mediaMap).forEach((key) => {
        if (mediaMap[key].asset_id) {
            operations.push({ [MUTATE_OPERATION_TYPES.SET]: { index: key, asset_id: mediaMap[key].asset_id } });
        }
    });
    return {
        type: PRODUCT_MEDIA.MEDIA_ASSETS.MUTATE.START,
        payload: {
            url: `${siteConfig.goAPI}/v1/coreproduct/${productId}/media`,
            body: { product_id: productId, revision, operations },
            errors,
        },
    };
};

export const update = (payload: Partial<IMediaState>) => ({ type: PRODUCT_MEDIA.UPDATE, payload });
export const resetProductMedia = () => ({ type: PRODUCT_MEDIA.RESET });
export const resetProductMediaAssets = () => ({ type: PRODUCT_MEDIA.MEDIA_ASSETS.RESET });

const upload = (id: string, body: IImageAsset | I360Asset | IVideoAsset | I3DAsset) => ({
    type: PRODUCT_MEDIA.UPLOAD.START,
    payload: { url: `${siteConfig.goAPI}/v1/coreproducts/${id}/assets`, body },
});

export const fetchManifest = (url: string) => (dispatch: Dispatch<{}>, getStore: () => IStore) => {
    const manifest = getStore().mediaManifest.payload;
    if (!manifest || manifest.url !== url) {
        dispatch({ type: PRODUCT_MEDIA.IMAGE_360.MANIFEST.START, payload: { url } });
    }
};
